import { createSlice } from "@reduxjs/toolkit";
import { useDispatch, useSelector } from "react-redux";

const mediaQuery = window.matchMedia("(max-width: 991px)");

export const sidebarSlice = createSlice({
    name: 'sidebar',
    initialState: {
        value: mediaQuery.matches ? false : true
    },
    reducers: {
        toggleSidebar: state => {
            state.value = !state.value;
        }
    }
})

export const { toggleSidebar } = sidebarSlice.actions;
export default sidebarSlice.reducer;


// Custom Hook
export const useSidebar = () => {
    const dispatch = useDispatch();
    const sidebar = useSelector(state => state.sidebar.value);

    return { sidebar, toggleSidebar: () => dispatch(toggleSidebar())};
}
